(()=>{
  const init=scope=>{
    const stories=scope.matches?.('[data-hotel-story]')?[scope]:scope.querySelectorAll('[data-hotel-story]');
    stories.forEach(story=>{
      if(story.dataset.hotelReady)return;
      story.dataset.hotelReady='true';
      const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
      const controller=new AbortController();
      const signal=controller.signal;
      const observers=[];
      const scroller=story.closest('.page-wrapper');
      const root=scroller&&getComputedStyle(scroller).overflowY.match(/auto|scroll/)?scroller:null;
      const revealItems=[...story.querySelectorAll('[data-hotel-reveal]')];
      const showAll=()=>revealItems.forEach(item=>item.classList.add('mh-visible'));
      if('IntersectionObserver' in window&&!reduced.matches){
        story.classList.add('mh-enhanced');
        const revealObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
          if(entry.isIntersecting){entry.target.classList.add('mh-visible');revealObserver.unobserve(entry.target)}
        }),{root,threshold:.08,rootMargin:'0px 0px -30px 0px'});
        revealItems.forEach(item=>revealObserver.observe(item));
        observers.push(revealObserver);
      }else showAll();
      const video=story.querySelector('[data-hotel-loop]');
      const film=video?.closest('.mh-rest');
      const button=film?.querySelector('.mh-motion-toggle');
      let inView=false;
      let explicitlyPaused=reduced.matches||Boolean(navigator.connection?.saveData);
      let frame=0;
      const sync=()=>{
        if(!video||!button)return;
        const label=video.paused?button.dataset.labelPlay:button.dataset.labelPause;
        button.textContent=label;
        button.setAttribute('aria-label',label);
      };
      const loadVideo=()=>{
        const source=video.querySelector('source[data-src]');
        if(source&&!source.src){source.src=source.dataset.src;video.load()}
      };
      const play=()=>{
        loadVideo();
        video.play().catch(sync);
      };
      const autoPlayback=()=>{
        if(!video)return;
        if(inView&&!document.hidden&&!explicitlyPaused)play();
        else video.pause();
      };
      const updateFilm=()=>{
        frame=0;
        if(!film||!inView||reduced.matches||window.innerWidth<750)return;
        const bounds=film.getBoundingClientRect();
        const top=root?root.getBoundingClientRect().top:0;
        const height=root?root.clientHeight:window.innerHeight;
        const progress=Math.min(1,Math.max(0,(height+top-bounds.top)/(height+bounds.height)));
        film.style.setProperty('--mh-film-scale',(1.035-progress*.035).toFixed(4));
      };
      const scroll=()=>{if(!frame&&inView&&!reduced.matches)frame=requestAnimationFrame(updateFilm)};
      if(video&&button){
        video.muted=true;
        video.loop=true;
        video.playsInline=true;
        video.setAttribute('muted','');
        video.addEventListener('error',sync,{signal});
        video.addEventListener('play',sync,{signal});
        video.addEventListener('pause',sync,{signal});
        button.addEventListener('click',()=>{
          if(video.paused){explicitlyPaused=false;play()}
          else{explicitlyPaused=true;video.pause()}
        },{signal});
        if('IntersectionObserver' in window){
          const filmObserver=new IntersectionObserver(entries=>{
            inView=entries.some(entry=>entry.isIntersecting);
            autoPlayback();scroll();
          },{root,threshold:.03});
          filmObserver.observe(film);
          observers.push(filmObserver);
        }else{inView=true;autoPlayback()}
        document.addEventListener('visibilitychange',autoPlayback,{signal});
        (root||window).addEventListener('scroll',scroll,{passive:true,signal});
        window.addEventListener('resize',scroll,{passive:true,signal});
        sync();
      }
      reduced.addEventListener('change',event=>{
        if(event.matches){explicitlyPaused=true;video?.pause();showAll();film?.style.removeProperty('--mh-film-scale')}
        else scroll();
      },{signal});
      story.hotelCleanup=()=>{
        controller.abort();observers.forEach(observer=>observer.disconnect());
        cancelAnimationFrame(frame);video?.pause();
      };
    });
  };
  init(document);
  if(!window.mtHotelEventsBound){
    window.mtHotelEventsBound=true;
    document.addEventListener('shopify:section:load',event=>init(event.target));
    document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-hotel-story]').forEach(story=>story.hotelCleanup?.()));
  }
})();
